import styled from '@emotion/styled';
import { Button, Stack } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

const LargeButton = styled(Button)`
  height: 62px;
  font-size: 20px;
  padding: 18px 38px;
  font-weight: normal;
`;

const StyledStack = styled(Stack)`
  justify-content: center;
`;

export interface SummaryActionProps {
  mode: 'create' | 'edit';
  isSaving: boolean;
  onSave: (redirectAfterSave?: boolean) => void;
  onCopy: () => void;
}

export const SummaryActions = ({
  isSaving,
  mode,
  onCopy,
  onSave,
}: SummaryActionProps): JSX.Element => {
  const { t } = useTranslation('feedback', { keyPrefix: 'survey-wizard-summary-actions' });

  const loadingText = t('loading');

  return (
    <StyledStack spacing="x2" direction="row">
      {mode === 'create' && (
        <LargeButton onClick={() => onSave()} isLoading={isSaving} loadingText={loadingText}>
          {t('create-survey')}
        </LargeButton>
      )}
      {mode === 'edit' && (
        <>
          <LargeButton onClick={() => onSave(false)} isLoading={isSaving} loadingText={loadingText}>
            {t('save')}
          </LargeButton>
          <LargeButton
            kind="secondary"
            onClick={() => onSave()}
            isLoading={isSaving}
            loadingText={loadingText}
          >
            {t('save-and-close')}
          </LargeButton>
          <LargeButton kind="secondary" onClick={onCopy}>
            {t('create-copy')}
          </LargeButton>
        </>
      )}
    </StyledStack>
  );
};
